module.exports = __webpack_public_path__ + "images/interview-Kaiser_Permanente-2.svg";